
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ErrorBoundary } from '@/components/ui/error-boundary';
import { Sidebar as SidebarComponent, SidebarContent, useSidebar } from '@/components/ui/sidebar';

// Import our new modular components
import SidebarHeader from './sidebar/SidebarHeader';
import NavItem from './sidebar/NavItem';
import SidebarFooter from './sidebar/SidebarFooter';
import { mainNavItems } from './sidebar/navigationItems';
import NavGroup from './sidebar/NavGroup';

const Sidebar = () => {
  const location = useLocation();
  const [isLoaded, setIsLoaded] = useState(false);
  const { state } = useSidebar();
  const isMobile = useSidebar().isMobile;
  const setOpenMobile = useSidebar().setOpenMobile;
  
  useEffect(() => {
    // Ensure sidebar is marked as loaded after mounting
    setIsLoaded(true);
    console.log("Sidebar loaded, state:", state);
  }, [state]);
  
  // Close mobile sidebar when navigating
  useEffect(() => {
    if (isMobile) {
      setOpenMobile(false);
    }
  }, [location.pathname, isMobile, setOpenMobile]);
  
  // Add a simple loading state to avoid rendering issues
  if (!isLoaded) {
    return <div className="bg-sidebar h-screen w-[200px] fixed left-0 top-0"></div>;
  }
  
  return (
    <ErrorBoundary
      fallback={
        <div className="bg-sidebar h-screen w-[60px] md:w-[200px] fixed left-0 top-0 flex items-start justify-center pt-4">
          <span className="text-sidebar-foreground">Menu</span>
        </div>
      }
      componentName="Sidebar"
    >
      <SidebarComponent variant="sidebar" collapsible="icon" className="flex flex-col h-full">
        <SidebarHeader />
        
        <SidebarContent className="flex-1 overflow-y-auto">
          <NavGroup label="Navegação" errorBoundaryName="SidebarNavigationMenu">
            {mainNavItems.map((item) => (
              <NavItem 
                key={item.path}
                icon={item.icon}
                label={item.label}
                path={item.path}
                isActive={location.pathname === item.path}
              />
            ))}
          </NavGroup>
        </SidebarContent>
        
        {/* Footer should be sticky at bottom and always visible */}
        <div className="mt-auto">
          <SidebarFooter />
        </div>
      </SidebarComponent>
    </ErrorBoundary>
  );
};

export default Sidebar;
